import script from "./VacancySection.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancySection.vue?vue&type=script&setup=true&lang=js"

import "./VacancySection.vue?vue&type=style&index=0&id=55d40fc2&lang=scss"

const __exports__ = script;

export default __exports__